
































































































































































import { ApplicationState } from "@/models";
import { State } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "NavigationDrawer"
})
export default class NavigationDrawer extends Vue {
  // ===== State ===== //
  @State("application") public application!: ApplicationState;
  // ===== Computed ===== //
  get hideIPRC(): boolean {
    return process.env.VUE_APP_HIDE_IPRC === "true";
  }
}
